import { DatePicker, Select, TextInput } from "components/inputs";
import type { CardConfig } from "./FMCMSSubmission";

export const getCMSSubmissionFields = (): CardConfig[] => [
  {
    cardName: "CMS SUBMISSION DETAILS",
    cardNumber: 1,
    style: {
      width: "100%",
      backgroundColor: "#ffffff",
    },
    componentProps: {},
    fields: [
      {
        label: "Submission Status",
        component: Select,
        apiField: "has_been_submitted_to_cms",
        componentProps: {
          options: [
            { value: false, label: "Not Submitted" },
            { value: true, label: "Submitted" },
          ],
          isClearable: false,
        },
      },
      {
        label: "Date Requested",
        component: DatePicker,
        apiField: "date_requested",
        componentProps: {
          placeholder: "MM/DD/YYYY",
          mask: "date",
        },
      },
      {
        label: "Date Approved",
        component: DatePicker,
        apiField: "date_approved",
        componentProps: {
          placeholder: "MM/DD/YYYY",
          mask: "date",
        },
      },
      {
        label: "Date Submitted",
        component: DatePicker,
        apiField: "date_submitted",
        componentProps: {
          placeholder: "MM/DD/YYYY",
          mask: "date",
        },
      },
      {
        label: "Notice of Submit Delivered to Client Date",
        component: DatePicker,
        apiField: "notice_of_submit_delivered_on",
        componentProps: {
          placeholder: "MM/DD/YYYY",
          mask: "date",
        },
      },
      // CCN lives here, not in its own card below.
      {
        label: "CCN",
        component: TextInput,
        apiField: "case_control_number",
        componentProps: {
          // Same placeholder style as CCN on ClaimMSA.tsx.
          placeholder: "X".repeat(15),
          maxLength: 15,
        },
      },
    ],
  },
];
